import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import '../../../../assets/stylesheets/Dialogs/Create.scss';
import { requestCreateClub } from '../../../../store/actionCreators/club';
import { Form } from 'react-bootstrap';

const Create = ({ code }) => {
  const { t } = useTranslation();
    const dispatch = useDispatch();
   const [newImageName, setNewImageName]  = useState();
   const [formState, setFormState] = useState({
        uploadedImage: '',
        username: '',
        description: ''
   });

   const handleChange = event => {
    event.persist();
    setFormState(formState => ({
        ...formState,
          [event.target.name]: event.target.value,
        }
      ))
   };
   const handleCreateClub = () => {
       const {username: name, description, uploadedImage: avatar} = formState;
       dispatch(requestCreateClub({ name, description, avatar, code }));
   };
   const  changeClubImage = (e) => {
        var reader = new FileReader();
        let fileName = e.target.value.split("\\");
        fileName = fileName[fileName.length - 1].split(".")[0];
        setNewImageName(fileName);
        if (e.target.files[0]) {
            reader.readAsDataURL(e.target.files[0]);
        }
        reader.onload = function () {
            setTimeout(() => {
                setFormState(formState => ({
                    ...formState,
                    uploadedImage: reader.result
                })
                )
            }, 500)
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    }

    return (
        <React.Fragment>
            <div className={`createClub`}>
                <div className={"currentClubAvatar"}>
                    <div className={"avatarFrame"}>
                        <span className="changeAvatar">{t('change')}</span>
                        <input id={"uploadAvatar"} type="file" accept="image/*"
                        onChange={changeClubImage}
                        />
                        {formState.uploadedImage ? (<div className={'uploadAvatarPreview'} style={{backgroundImage: 'url(' + formState.uploadedImage + ')'}}></div>) : ''}
                    </div>
                </div>
                <Form.Group className={`clubName`}>
                    <Form.Label className={`label`}>
                        {t('clubName')}
                    </Form.Label>
                    <Form.Control
                        type="text"
                        name="username"
                        value={formState.username}
                        onChange={handleChange}
                    />
                </Form.Group>
                <Form.Group className={`description`}>
                    <Form.Label className={`label`}>
                        {t('clubDescriptionAndRules')}
                    </Form.Label>
                    <textarea
                        value={formState.description}
                        type="text"
                        min="2"
                        max="512"
                        name="description"
                        cols="37"
                        rows="6"
                        onChange={handleChange}
                    />
                </Form.Group>
                <div className="dialogConfirmBox">
                    <button
                    className="primary"
                    onClick={handleCreateClub}
                    >{t('button.submit')}</button>
                </div>
            </div>
        </React.Fragment>
    );
};

export default Create;
